import { useState } from "react";
import { ChevronRight, Utensils } from "lucide-react";

export default function CartBar({ itemCount, itemImages = [], onOpenCart }) {
  const [brokenIdx, setBrokenIdx] = useState(() => new Set());
  if (itemCount <= 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] animate-in slide-in-from-bottom-5 duration-300">
      <button
        onClick={onOpenCart}
        className="bg-[#520400] hover:bg-[#3A0300] text-white rounded-full px-4 py-2 sm:px-6 sm:py-3 shadow-2xl flex items-center gap-3 sm:gap-4 border border-red-400/40 transition-all transform active:scale-95 cursor-pointer shrink-0"
      >
        <div className="flex items-center -space-x-2.5 shrink-0">
          {itemImages.length > 0 ? (
            itemImages.map((img, idx) => (
              <div key={idx} className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-white overflow-hidden shadow-xs bg-slate-100 flex items-center justify-center shrink-0" style={{ zIndex: 10 - idx }}>
                {img && !brokenIdx.has(idx) ? (
                  <img
                    src={img}
                    alt="Cart item"
                    onError={() => setBrokenIdx((prev) => new Set(prev).add(idx))}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <Utensils className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-slate-300" strokeWidth={1.5} />
                )}
              </div>
            ))
          ) : (
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-white overflow-hidden shadow-xs bg-slate-100 flex items-center justify-center">
              <Utensils className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-slate-300" strokeWidth={1.5} />
            </div>
          )}
        </div>

        <div className="shrink-0 text-left leading-none">
          <div className="whitespace-nowrap text-white font-black text-sm sm:text-base tracking-tight">View cart</div>
          <div className="whitespace-nowrap text-white/90 text-xs sm:text-sm font-bold mt-0.5">{itemCount} Item(s)</div>
        </div>

        <div className="w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-[#FFF8F5] text-[#520400] flex items-center justify-center shadow-xs shrink-0 ml-0.5">
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 stroke-[3] text-[#520400]" />
        </div>
      </button>
    </div>
  );
}
